import buildConfig from './build-config.json';
import { console as ReproConsole } from './utility/console';
import { InspectorPluginPostMessageData } from './plugins/inspector/inspector.types';
import { TriggeredEvent } from './triggered-event.types';

export class InspectorPluginProxy {
  constructor(eventQueue: TriggeredEvent[] = []) {
    const target = document.getElementsByTagName('script')[0];
    if (target == null || target.parentNode == null) return;

    if (document.querySelector('script[id="repro-inspector-plugin"]') !== null) {
      ReproConsole.warn('Inspector plugin has already been loaded.');
      return;
    }

    // ファイルを別に分けているのは、基本的にこのinspectモードをオンにしない限りは
    // 余計なものを読み込みたくないから。万が一何か問題が起きたときに、サーバー側ですべてのinspectモードをオフにするか、
    // あるいはこの別ファイルの方を空にしてしまえば問題はなくなるはず
    const script = document.createElement('script');
    script.id = 'repro-inspector-plugin';
    script.src = buildConfig.inspectorPluginURL;
    script.async = true;
    script.crossOrigin = '';

    if (eventQueue.length > 0) {
      script.addEventListener('load', () => {
        this.dispatch(eventQueue);
      });
    }

    target.parentNode.insertBefore(script, target);
  }

  public dispatch(events: TriggeredEvent[]): void {
    window.postMessage(
      { type: 'repro-inspector-plugin-message-payload', payload: events } as InspectorPluginPostMessageData,
      window.location.origin
    );
  }

  public reset(): void {
    window.postMessage(
      {
        type: 'repro-inspector-plugin-message-reset',
      },
      window.location.origin
    );
  }
}
